import React from "react";
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import GoogleSearch from "google-search";
import LocalStorageService from "../services/LocalStorageService";
import CustomerStore from "../stores/CustomerStore";
import * as CustomerActions from "../actions/CustomerActions";
import {getUrlParameters} from "./utils/UrlUtils";
@connect ((store) =>{
     return {
       user: store.user.user,
       messages:store.messages.messages,
       offers: store.offer.offerList,
       subscriptions: store.subscription.subscriptionsList,
       invoices: store.invoice.invoices,
       isLoggedIn: !!store.user.user
     }
  }
)
@withRouter
export default class HeaderComponent extends React.Component {
    constructor() {
        super();
        this.state = {
            currentCustomer: null,
            isLoggedIn: false,
            searchTerm: null,
            menuClicked: true,
            mobileMenu: "none"
        };
        this.closeMenu = this.closeMenu.bind(this);
    }

    componentWillMount() {
        CustomerStore.bindUpdateHandler(this.renderHeader.bind(this));
        window.addEventListener("click", this.closeMenu);
    }
    componentWillUnmount() {
        CustomerStore.unbindUpdateHandler(this.renderHeader.bind(this));
        window.removeEventListener("click", this.closeMenu);
    }
    componentDidMount() {
        CustomerActions.getCurrentCustomer();
    }
    updateSearchTerm(event) {
        const searchTerm = event.target.value;
        this.setState({
            searchTerm: searchTerm
        });
    }
    renderHeader(currentCustomer) {
        this.setState({
            isLoggedIn: !!currentCustomer,
            currentCustomer
        });
    }
    login(event) {
        event.preventDefault();
        this.props.router.replace(dashboard_url.path);
    }

    logout(event) {
        event.preventDefault();
        CustomerActions.logoutCurrentCustomer();
        //window.location.href = customerSpace;
    }

    clickedOutsideOf(event, ids = []) {
        const clicked = ids.every(id => {
            return event.target.id !== id
                && event.target.parentNode.id !== id
                && event.target.parentNode.parentNode.id !== id;
        });
        return clicked;
    }
    toggleMenu() {
        const {mobileMenu} = this.state;
        this.setState({
            menuClicked: false,
            mobileMenu: (mobileMenu === "none" ? "block" : "none")
        });
    }

    closeMenu(event) {
        const {mobileMenu} = this.state;
        if (mobileMenu === "block" && this.clickedOutsideOf(event, [
                "mobile-menu",
                "settings-menu",
                "header-settings",
                "header-help",
                "header-search"
            ])) {
            this.setState({
                menuClicked: true,
                mobileMenu: (mobileMenu === "none" ? "block" : "none")
            });
        }
    }
    toggleMenuClose(event) {
        const {mobileMenu} = this.state;

        this.setState({
            menuClicked: true,
            mobileMenu: (mobileMenu === "none" ? "block" : "none")
        });
    }

        render() {
        const { currentCustomer,menuClicked } = this.state;
        const { name = {} } = currentCustomer || {};
        const { messages, user, isLoggedIn} = this.props;
        const email = !!user && user.email;
        const fullName = [name.firstName, name.lastName].join(" ");
        const source = LocalStorageService.get("sc_source", "");
        const sourceLabel = !!source ? "via " + source : "";
        const hasSource = !!sourceLabel;
        return (
            <nav id="header-navbar" className="navbar navbar-default navbar-fixed-top" role="navigation">
                <div className="navbar-wrapper">
                    <div className="navbar-header">
                        {menuClicked ?
                        <button id="mobile-menu" type="button" className="navbar-toggle" onClick={this.toggleMenu.bind(this)}>
                            <span className="icon-bar" />
                            <span className="icon-bar" />
                            <span className="icon-bar" />
                            <span style={{ "marginLeft": "-5px", "fontSize": "11" }} >MENU</span>
                        </button>
                        :
                        <button id="mobile-menu" type="button" className="navbar-toggle" onClick={this.toggleMenuClose.bind(this)}>
                         <span><img src="images/close_icon.png" className="img" /></span>
                        </button>
                        }
                        <Link to={subscriptionDetails_url.path} className="navbar-brand">
                            <img src={`${applicationPath}/images/logofnac.png`} className="logo img-responsive" />
                        </Link>
                        <div id="right-menu" >
                            <ul className="nav navbar-nav navbar-right">
                                <li>
                                    <div className="navbar-txt navbar-text-sm">
                                        <a target='_blank' href={onlineHelp}> 
                                            <span className="fa fa-question-circle" />
                                        </a>
                                    </div>
                                </li>
                                {isLoggedIn ?
                                    <li>
                                        <div className="navbar-txt navbar-text-sm">
                                            <Link to="/" onClick={this.logout.bind(this)}> <span className="fa fa-user"></span></Link>
                                        </div>
                                    </li>
                                    : null
                                }



                </ul>
                </div>
                    </div>
                    </div>
                    <div id="right-menu" className="collapse navbar-collapse" style={{ display: this.state.mobileMenu }}>
                        <ul className="nav navbar-nav navbar-right">
                            <li>
                                <div className='navbar-text navbar-text-sm primary-light-color'>
                                    <span>
                                        <i className='fa fa-question-circle question-icon' />
                                        <a target='_blank' href={onlineHelp}>{messages['common.label.online.help']}</a>
                                    </span>
                                </div>
                            </li>
                            {isLoggedIn ?
                                <li className="navbar-right">
                                    <div className='navbar-text navbar-text-sm primary-light-color'>
                                        <img src={`${applicationPath}/images/logout.png`} className='img' />
                                        <Link to='/' onClick={this.logout.bind(this)}>
                                            {messages['common.label.logout']}
                                        </Link>
                                    </div>
                                </li>
                                : null
                    }


                </ul>
                </div>

                {isLoggedIn ?
                    <div id="second-level-menu" className="collapse navbar-collapse navbar-second-level" style={{ display: this.state.mobileMenu }}>

                        <ul className="nav navbar-nav navbar-left">
                            <li >
                                <div className="navbar-text navbar-text-sm text-center">
                                    <p>{fullName}</p>
                                    <p>{email}</p>
                                </div>
                            </li>
                            <li><Link id="home" to={dashboard_url.path}>{messages["common.menu.dashboard"].toUpperCase()}</Link></li>
                            <li><Link to={mesAbonnements_url.path}>{messages["common.menu.my.subscriptions"].toUpperCase()}</Link></li>
                            <li><Link to={mesFactures_url.path}>{messages["common.menu.my.invoices"].toUpperCase()}</Link></li>
                            <li><Link to={mesCoordonnees_url.path}>{messages["common.menu.info.details"].toUpperCase()}</Link></li>
                            <li><Link to={myAssistance_url}>{messages["common.menu.my.assistance"].toUpperCase()}</Link></li>
                            <li>
                                <div className="navbar-lastText text-right">
                                <img src={`${applicationPath}/images/account-logout.png`} className="img" />
                                     <a onClick={this.logout.bind(this)}>{messages["common.label.logout"].toUpperCase()}</a>
                                </div>
                            </li>
                        </ul>

                    </div>
                    :
                    <div id="second-level-menu" className="collapse navbar-collapse navbar-second-level" style={{ display: this.state.mobileMenu }}>

                    </div>
                }
            </nav>
        );
    }
}



// WEBPACK FOOTER //
// ./src/opencell/pages/HeaderComponent.jsx